// extracted by mini-css-extract-plugin
module.exports = {"iconLink":"SocialIcon-module--iconLink--3lvyk","circle":"SocialIcon-module--circle--18tkR"};